import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import { Component, Input, OnInit, Output,EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import {Subscription} from 'rxjs';
import { GetEmpty } from 'src/app/classes/Empties';
import {KeyboardShortcutEvent} from 'src/app/classes/Utils';
import {ItemInfo, ItemOptionInfo, ItemOptionValueInfo, OrderItemInfo} from 'src/app/models/models';
import {Item_Option, Order_Item, Order_Item_Batch, Price} from 'src/app/models/RestModels';
import {BaseComponent} from 'src/app/pages/base/base.component';
import {ShortcutsService} from 'src/app/services/shortcuts.service';

interface Qty {
	item_option_value_id:number;
	qty:number;
}

type ChangeQuantitiesOption = 'FREE_EDIT_QUANTITIES' | 'SWAP_OPTIONS_ONLY' | 'SWAP_OPTIONS_KEEP_TOTAL';

@Component({
	selector: 'app-select-item-option',
	templateUrl: './select-item-option.component.html',
	styleUrls: ['./select-item-option.component.css']
})
export class SelectItemOptionComponent extends BaseComponent implements OnInit,OnChanges
{
	@Input() item_info:ItemInfo | null = null;
	@Output() orderItemInfoList = new EventEmitter<OrderItemInfo[]>();

	@Input() price_list_id:number | null = null;
	@Input() price_type_id:number = 1;
	@Input() tax_percent:number = 0;
	@Input() use_inputs:boolean = false;
	@Input() initial_option_dictionary:Record<number,number> = {};
	@Input() change_quantities_option:ChangeQuantitiesOption = 'FREE_EDIT_QUANTITIES';

	option_index: number	= 0;

	//lleva el contador de la cantidad de opciones seleccionadas
	option_dictionary:Record<number,number> = {};

	//Lleva el contador de
	//option_qty_dictionary:Record<number,number> = {};

	row_index: number = 0;
	keyboard_subscription: Subscription | null = null;
	item_focus_index:number = 0;
	item_option_values_queue_by_item_option_id:Record<number,Qty[]> = {}
	swap_source_option_value_id_by_item_option_id:Record<number,number> = {};

	@ViewChild(CdkVirtualScrollViewport) option_view_port: CdkVirtualScrollViewport;

	ngOnInit(): void
	{
		this.option_index = 0;
		this.setInitialOptions();
		this.row_index	= 0;
	}

	handleShortcuts(kse:KeyboardShortcutEvent)
	{
		if( !this.item_info )
			return;

		console.log('new event',kse);

		if( kse.shortcut.name == ShortcutsService.ESCAPE )
		{
			this.orderItemInfoList.emit([]);
			kse.stopPropagation();
			return;
		}

		if( kse.shortcut.name == ShortcutsService.SPACE )
		{
			if( this.item_info && this.item_info.options[ this.option_index ].values.length )
			{
				//console.log( this.item_info.options[ this.option_index ] );//.values[ this.row_index ] )
				this.optionClicked( this.item_info.options[ this.option_index ].values[this.row_index] );
				kse.stopPropagation();
			}
			return;
		}

		if( kse.shortcut.name == ShortcutsService.ENTER )
		{
			//kse.stopPropagation();
			return;
		}

		if( kse.shortcut.name == ShortcutsService.ARROW_UP && this.row_index > 0 )
		{
			this.row_index--;
			this.option_view_port.scrollToIndex(this.row_index, "smooth");
			kse.stopPropagation();
			return;
		}
		else if( kse.shortcut.name == ShortcutsService.ARROW_DOWN && this.row_index < this.item_info.options[ this.option_index ].values.length-1 )
		{
			this.row_index++;
			this.option_view_port.scrollToIndex(this.row_index, "smooth");
			kse.stopPropagation();
			return;
		}
		else if( kse.shortcut.name == ShortcutsService.ARROW_RIGHT && this.option_index < this.item_info.options.length-1 )
		{
			this.option_index++;
			this.option_view_port.scrollToIndex(this.row_index, "smooth");
			kse.stopPropagation();
			return;
		}
		else if( kse.shortcut.name == ShortcutsService.ARROW_LEFT && this.option_index > 0 )
		{
			this.option_index--;
			this.option_view_port.scrollToIndex(this.row_index, "smooth");
			kse.stopPropagation();
			return;
		}
	}

	ngOnChanges(changes: SimpleChanges): void
	{
		if('item_info' in changes || 'initial_option_dictionary' in changes )
		{
			this.setInitialOptions();

			if( 'item_info' in changes )
			{
				this.subs.unsubscribe();
				this.subs.sink = this.keyboard_subscription = this.shortcuts.shortcuts.subscribe((evt)=>this.handleShortcuts(evt));
			}
		}
	}

	canChangeQuantities():boolean
	{
		return this.change_quantities_option == 'FREE_EDIT_QUANTITIES';
	}

	isSwapMode():boolean
	{
		return this.change_quantities_option == 'SWAP_OPTIONS_ONLY'
			|| this.change_quantities_option == 'SWAP_OPTIONS_KEEP_TOTAL';
	}

	getFocusedOptionValue():ItemOptionValueInfo | null
	{
		if( !this.item_info )
			return null;

		let item_option = this.item_info.options[ this.option_index ];
		if( !item_option )
			return null;

		return item_option.values[ this.row_index ] || null;
	}

	setInitialOptions()
	{
		this.option_dictionary = {};
		this.item_option_values_queue_by_item_option_id = {};
		this.swap_source_option_value_id_by_item_option_id = {};

		if( !this.item_info || !this.initial_option_dictionary )
			return;

		this.item_info.options.forEach((ioi)=>
		{
			ioi.values.forEach((iovi)=>
			{
				let qty = this.initial_option_dictionary[iovi.item_option_value.id] || 0;
				if( qty <= 0 )
					return;

				let item_option_id = iovi.item_option_value.item_option_id;
				this.option_dictionary[iovi.item_option_value.id] = qty;

				if( !(item_option_id in this.item_option_values_queue_by_item_option_id) )
				{
					this.item_option_values_queue_by_item_option_id[item_option_id] = [];
				}

				this.item_option_values_queue_by_item_option_id[item_option_id].push({
					item_option_value_id: iovi.item_option_value.id,
					qty
				});
			});
		});
	}

	onQtyInputChange(iovi:ItemOptionValueInfo, new_qty:number)
	{
		if( !this.canChangeQuantities() )
			return;

		if( new_qty === null || new_qty === undefined || new_qty < 0 )
		{
			new_qty = 0;
		}

		if( iovi.item_option_value.max_extra_qty && new_qty > iovi.item_option_value.max_extra_qty )
		{
			new_qty = iovi.item_option_value.max_extra_qty;
		}

		let item_option_id = iovi.item_option_value.item_option_id;
		this.option_dictionary[ iovi.item_option_value.id ] = new_qty;

		if( !(item_option_id in this.item_option_values_queue_by_item_option_id ) )
		{
			this.item_option_values_queue_by_item_option_id[ item_option_id ] = [];
		}

		let queue = this.item_option_values_queue_by_item_option_id[ item_option_id ];
		let index = queue.findIndex((i:Qty)=>i.item_option_value_id == iovi.item_option_value.id);

		if( new_qty > 0 )
		{
			if( index == -1 )
			{
				queue.push({ item_option_value_id: iovi.item_option_value.id, qty: new_qty });
			}
			else
			{
				queue[index].qty = new_qty;
			}
		}
		else
		{
			if( index > -1 )
			{
				queue.splice(index, 1);
			}
		}
	}

	optionClicked(iovi:ItemOptionValueInfo)
	{
		let item_option_id:number = iovi.item_option_value.item_option_id;
		let item_option:ItemOptionInfo = this.item_info.options[ this.option_index ];

		let index =	item_option.values.findIndex( (v)=> v.item_option_value.id == iovi.item_option_value.id );

		if( index > -1 )
		{
			if( this.row_index != index )
			{
				this.row_index = index;
			}
		}

		if( !this.canChangeQuantities() )
		{
			this.replaceOptionValue(iovi);
			return;
		}

		//if( this.use_inputs )
		//{
		//	return;
		//}

		if( !(iovi.item_option_value.id in this.option_dictionary) )
		{
			this.addOneItemOptionValueInfo(iovi, item_option.item_option);
		}
		else if( iovi.item_option_value.max_extra_qty <= this.option_dictionary[ iovi.item_option_value.id ] )
		{
			this.removeItemOptionValueInfo(iovi);
			return;
		}
		else
		{
			this.addOneItemOptionValueInfo(iovi, item_option.item_option);
		}

		//Checamos si se pasa y le quitamos
		let total_selected:number =0;
		let max_options:number = 0;

		item_option.values.forEach((iovi2:ItemOptionValueInfo)=>
		{
			if( this.option_dictionary[ iovi2.item_option_value.id ] )
			{
				total_selected+= this.option_dictionary[ iovi2.item_option_value.id ];
				max_options++;
			}
		});

		//console.log( this.option_dictionary )
		//console.log( item_option.item_option.max_options);
		//console.log( 'Max options', max_options, item_option.item_option.max_options );

		if( max_options > item_option.item_option.max_options )
		{
			if( this.item_option_values_queue_by_item_option_id[ item_option_id ] && this.item_option_values_queue_by_item_option_id[ item_option_id ].length )
			{
				let id = this.item_option_values_queue_by_item_option_id[ item_option_id ][0].item_option_value_id;
				let iovi2	= item_option.values.find(i=>i.item_option_value.id==id);
				this.removeItemOptionValueInfo( iovi2 );
				return;
			}
			else
			{
				console.log('Fallo en el sistema');
			}
		}

		let max_selections = this.getMaxSelections(item_option.item_option);

		if( max_selections !== null && total_selected > max_selections )
		{
			if( this.item_option_values_queue_by_item_option_id[ item_option_id ] && this.item_option_values_queue_by_item_option_id[ item_option_id ].length )
			{
				let qty = this.item_option_values_queue_by_item_option_id[ item_option_id ][0];

				if( qty.qty > 0 )
				{
					let id = this.item_option_values_queue_by_item_option_id[ item_option_id ][0].item_option_value_id;
					let iovi2	= item_option.values.find(i=>i.item_option_value.id==id);
					this.removeOneItemOptionValueInfo( iovi2 );
				}
				else
				{
					//console.log('Posible error en el sistema xddkdas');
				}
			}
			else
			{
				//console.log('Posible error en el sistema codigo2 ffffff');
			}
		}
	}

	replaceOptionValue(iovi:ItemOptionValueInfo)
	{
		let item_option_id = iovi.item_option_value.item_option_id;
		let queue = this.item_option_values_queue_by_item_option_id[item_option_id];

		if( !queue || !queue.length )
			return;

		if( this.option_dictionary[iovi.item_option_value.id] )
		{
			this.swap_source_option_value_id_by_item_option_id[item_option_id] = iovi.item_option_value.id;
			return;
		}

		let source_option_value_id = this.swap_source_option_value_id_by_item_option_id[item_option_id];
		if( !source_option_value_id )
		{
			this.showError('Seleccione primero la opcion que desea cambiar');
			return;
		}

		let source_index = queue.findIndex((qty:Qty)=>qty.item_option_value_id == source_option_value_id);
		if( source_index == -1 )
		{
			delete this.swap_source_option_value_id_by_item_option_id[item_option_id];
			this.showError('Seleccione primero la opcion que desea cambiar');
			return;
		}

		let qty = queue[source_index];

		this.option_dictionary[source_option_value_id] = 0;
		this.option_dictionary[iovi.item_option_value.id] = qty.qty;

		queue.splice(source_index, 1, {
			item_option_value_id: iovi.item_option_value.id,
			qty: qty.qty
		});

		delete this.swap_source_option_value_id_by_item_option_id[item_option_id];
	}

	isSwapSourceOptionValue(iovi:ItemOptionValueInfo):boolean
	{
		if( !this.isSwapMode() )
			return false;

		return this.swap_source_option_value_id_by_item_option_id[iovi.item_option_value.item_option_id] == iovi.item_option_value.id;
	}

	getSwapSourceOptionValue():ItemOptionValueInfo | null
	{
		if( !this.isSwapMode() )
			return null;

		if( !this.item_info )
			return null;

		let item_option = this.item_info.options[ this.option_index ];
		if( !item_option )
			return null;

		let source_option_value_id = this.swap_source_option_value_id_by_item_option_id[item_option.item_option.id];
		if( !source_option_value_id )
			return null;

		return item_option.values.find((iovi:ItemOptionValueInfo)=>iovi.item_option_value.id == source_option_value_id) || null;
	}

	getTotalByOptionId(item_option_id:number):number
	{
		if(!(item_option_id in this.item_option_values_queue_by_item_option_id ) )
			return 0;

		return this.item_option_values_queue_by_item_option_id[ item_option_id ]
		.reduce((p,c)=>
		{
			return p+c.qty;
		},0);
	}

	getInitialTotalByOptionId(item_option:ItemOptionInfo):number
	{
		return item_option.values.reduce((sum, iovi)=>
		{
			return sum + (this.initial_option_dictionary[iovi.item_option_value.id] || 0);
		}, 0);
	}

	validateOptionTotalsAreMaintained():boolean
	{
		if( this.change_quantities_option != 'SWAP_OPTIONS_KEEP_TOTAL' )
			return true;

		let invalid_option = this.item_info.options.find((ioi)=>
		{
			return this.getTotalByOptionId(ioi.item_option.id) != this.getInitialTotalByOptionId(ioi);
		});

		if( invalid_option )
		{
			this.showError('No se puede cambiar la cantidad total de "'+invalid_option.item_option.name+'"');
			return false;
		}

		return true;
	}

	getMaxSelections(item_option:Item_Option):number | null
	{
		if( item_option.max_extra_qty && item_option.max_extra_qty > 0 )
			return item_option.max_extra_qty;

		if( item_option.min_selections && item_option.min_selections > 0 )
			return item_option.min_selections;

		if( item_option.max_options && item_option.max_options > 0 )
			return item_option.max_options;

		return null;
	}

	addOneItemOptionValueInfo(iovi:ItemOptionValueInfo, item_option:Item_Option)
	{
		let item_option_id = iovi.item_option_value.item_option_id;
		let to_add = 1;

		if( !(iovi.item_option_value.id in this.option_dictionary) )
		{
			let qtities = this.item_option_values_queue_by_item_option_id[ item_option.id ];
			let to_add = !qtities ? iovi.item_option_value.max_extra_qty : 1;

			this.option_dictionary[ iovi.item_option_value.id ] = to_add || 1;
		}
		else
		{
			this.option_dictionary[ iovi.item_option_value.id ]++;
		}

		if( !(item_option_id in this.item_option_values_queue_by_item_option_id ) )
		{
			this.item_option_values_queue_by_item_option_id[ item_option_id ] = [];
		}

		let qty:Qty = {
			item_option_value_id: iovi.item_option_value.id,
			qty: 0
		}

		let index = this.item_option_values_queue_by_item_option_id[ item_option_id ].findIndex((i:Qty)=>i.item_option_value_id == iovi.item_option_value.id);

		if( index == -1 )
		{
			this.item_option_values_queue_by_item_option_id[ item_option_id ].push( qty );

			//1 por que se acaba de agregar, no habia ninguno
			if( this.item_option_values_queue_by_item_option_id[ item_option_id ].length	== 1 )
			{
				qty.qty = item_option.min_selections || 1;
				this.option_dictionary[ iovi.item_option_value.id ] = qty.qty;
			}
			else
			{
				qty.qty++;
			}
		}
		else
		{
			//qty = this.item_option_values_queue_by_item_option_id[ item_option_id ][index];
			let qty_array:Qty[] = this.item_option_values_queue_by_item_option_id[ item_option_id ].splice(index,1);
			qty = qty_array[0];
			this.item_option_values_queue_by_item_option_id[item_option_id].push( qty );
			qty.qty++;
		}
	}

	removeOneItemOptionValueInfo(iovi:ItemOptionValueInfo):void
	{

		let item_option_id = iovi.item_option_value.item_option_id;

		if( !(iovi.item_option_value.id in this.option_dictionary) )
		{
			this.option_dictionary[ iovi.item_option_value.id ] = 1;
		}

		this.option_dictionary[ iovi.item_option_value.id ]--;


		if( this.item_option_values_queue_by_item_option_id[ item_option_id ] && this.item_option_values_queue_by_item_option_id[ item_option_id ].length )
		{
			let index = this.item_option_values_queue_by_item_option_id[ item_option_id ].findIndex((i:Qty)=>i.item_option_value_id == iovi.item_option_value.id);

			if( index> -1 )
			{
				this.item_option_values_queue_by_item_option_id[ item_option_id ][index].qty--;
			}

			if( this.item_option_values_queue_by_item_option_id[ item_option_id ][index].qty == 0 )
			{
				this.item_option_values_queue_by_item_option_id[ item_option_id ].splice(index,1);
			}
		}
		else
		{
			console.error( 'Posible error del sistema no se encontrol el indice' );
		}
	}

	removeItemOptionValueInfo(iovi:ItemOptionValueInfo):void
	{
		let item_option_id = iovi.item_option_value.item_option_id;

		if( iovi?.item_option_value?.id && !(iovi?.item_option_value?.id in this.option_dictionary) )
		{
			this.option_dictionary[ iovi.item_option_value.id ] = 1;
		}

		this.option_dictionary[ iovi.item_option_value.id ] = 0;

		if( this.item_option_values_queue_by_item_option_id[ item_option_id ] && this.item_option_values_queue_by_item_option_id[ item_option_id ].length )
		{
			let index = this.item_option_values_queue_by_item_option_id[ item_option_id ].findIndex((i:Qty)=>i.item_option_value_id == iovi.item_option_value.id);

			if( index> -1 )
			{
				this.item_option_values_queue_by_item_option_id[ item_option_id ].splice(index,1);
			}
		}
		else
		{
			console.error( 'Posible error del sistema no se encontrol el indice' );
		}
	}

	prev()
	{
		this.option_index--;
	}
	next()
	{
		let ioiv = this.item_info.options[ this.option_index ];

		if( ioiv.item_option.min_options )
		{
			let qtities = this.item_option_values_queue_by_item_option_id[ ioiv.item_option.id ];

			if( !qtities && ioiv.item_option.min_options )
			{
				this.showError('Seleccione al menos "'+ioiv.item_option.min_options+'" Opcion');
				return;
			}

			let counter = qtities.reduce((c,qty)=>{
				return c+(qty.qty?1:0);
			},0);

			if( counter < ioiv.item_option.min_options )
			{
				this.showError('Debes seleccionar al menos "'+ioiv.item_option.min_options+'" opciones');
				return ;
			}
		}

		if( ioiv.item_option.min_selections )
		{
			let qtities = this.item_option_values_queue_by_item_option_id[ ioiv.item_option.id ];

			let counter = qtities.reduce((c,qty)=>{
				return c+qty.qty;
			},0);

			if( counter < ioiv.item_option.min_selections)
			{
				this.showError('Debes seleccionar al menos "'+ioiv.item_option.min_selections+'" ');
				return;
			}
		}

		this.option_index++;
	}

	done()
	{
		let items:OrderItemInfo[] =[];

		//let price:Price = this.item_info.prices.find((i:Price)=>
		//{
		//	return i.price_list_id == this.price_list_id && this.price_type_id == i.price_type_id
		//});

		let order_item_info = GetEmpty.orderItemInfo
		(
			this.item_info.item,
			this.item_info.category,
			this.item_info.price,
			this.item_info.exceptions,
			this.item_info.prices
		);

		this.rest.updateOrderItemPrice( order_item_info.order_item, this.tax_percent, 0);

		items.push( order_item_info );

		let item_ids = [ this.item_info.item.id ];


		let min_valid = false;

		let is_invalid = this.item_info.options.some((ioi:ItemOptionInfo)=>
		{
			if( ioi.item_option.min_options == 0 )
				return false;

			//Return if som item option is invalid
			let ioi_id = ioi.item_option.id;
			let qtities = this.item_option_values_queue_by_item_option_id[ ioi_id ];

			if( !qtities && ioi.item_option.min_options )
			{
				this.showError('Por favor seleccione al menos "'+ioi.item_option.min_options+'" opciones');
				return true;
			}

			let counter = qtities.reduce((c,qty)=>{
				return c+(qty.qty?1:0);
			},0);


			if( counter < ioi.item_option.min_options )
			{
				this.showError('Por favor seleccione al menos "'+ioi.item_option.min_options+'" opciones');
				return true;
			}

			//true if is invalid
			return false;
		});

		if( is_invalid )
		{
			//this.showError('No cumple con el minimo');
			return;
		}

		if( !this.validateOptionTotalsAreMaintained() )
			return;

		this.item_info.options.forEach((ioi:ItemOptionInfo)=>
		{
			let ioi_id = ioi.item_option.id;
			if( ioi_id in this.item_option_values_queue_by_item_option_id )
			{
				let qtities = this.item_option_values_queue_by_item_option_id[ ioi_id ];
				qtities.forEach((qty)=>
				{
					if( qty.qty > 0 )
					{
						let iovi = ioi.values.find(i=>i.item_option_value.id == qty.item_option_value_id );
						if( iovi )
						{
							item_ids.push( iovi.item.id );

							let unitary_price:number = iovi.item_option_value.extra_price;
							let created = new Date();
							created.setTime(order_item_info.order_item.item_group);

							let tmp:Order_Item =
							{
								discount: 0,
								discount_percent: 0,
								exceptions: '',
								offer_id: null,
								id: 0,
								has_separator: 'NO',
								reservation_item_id: null,
								ieps_calculated: 0,
								ieps_type:'RATE',
								ieps_value: 0,
								item_id: iovi.item.id,
								item_group: order_item_info.order_item.item_group,
								item_option_id: iovi.item_option_value.item_option_id,
								original_unitary_price: unitary_price,
								unitary_price_meta: unitary_price,
								unitary_price: 0,
								tax_included: order_item_info.order_item.tax_included,
								is_free_of_charge: unitary_price > 0 ? 'NO' : 'YES',
								stock_status: 'IN_STOCK',
								status: 'ACTIVE',
								type:'NORMAL',
								tax: 0,
								total: 0,
								subtotal: 0,
								qty:qty.qty,
								item_option_qty: qty.qty,
								note: ''
							};

							let prices:Price[] = [];
							let options:ItemOptionInfo[] = [];

							items.push
							({
								prices,
								options,
								order_item:tmp,
								item: iovi.item,
								category: iovi.category,
								records: [],
								exceptions: this.item_info.exceptions,
								order_item_exceptions: [],
								serials: [],
								serials_string: '',
								batches: [] as Order_Item_Batch[],
								created,
								commanda_type_id: iovi.item.commanda_type_id
							});
						}
						else
						{
							console.warn('Error no se encontro el indice');
						}
					}
				});
			}
		});
		this.orderItemInfoList.emit(items);
	}

	cancelar()
	{
		this.orderItemInfoList.emit([]);
		this.option_index = 0;
		this.item_info = null;
	}
}
